import classes from "./MetricShaftMachiningExtraSubstep.module.less";
import SubstepFrame from "~/Configurators/Linear/components/SubstepFrame";
import { type LinearSubstep, SimpleCsticId } from "~/Configurators/Linear/models";
import { useSelector } from "react-redux";
import { selectCstic } from "~/Configurators/Linear/redux/selectCstic";
import {
  SHAFT_MACHINING_LEFT,
  SHAFT_MACHINING_MIDDLE,
  SHAFT_MACHINING_RIGHT,
} from "~/Configurators/Shaft/metric/metricCsticConstants";
import { useXmlConfiguratorTranslations } from "~/Configurators/common/useXmlConfiguratorTranslations";
import { MetricShaftAxialThreadSegment } from "~/Configurators/Shaft/metric/components/MetricShaftMachiningExtraSubstep/segments/MetricShaftAxialThreadSegment";
import { MetricShaftChamferSegment } from "~/Configurators/Shaft/metric/components/MetricShaftMachiningExtraSubstep/segments/MetricShaftChamferSegment";
import { MetricShaftRadialThreadSegment } from "~/Configurators/Shaft/metric/components/MetricShaftMachiningExtraSubstep/segments/MetricShaftRadialThreadSegment";
import {
  showAxialThreadSection,
  showChamferedSection,
  showRadialThreadSection,
} from "~/Configurators/Shaft/shaftConfiguratorHelper";
import { useTranslation } from "react-i18next";
import LanguageAwareExternalContent from "~/Configurators/Linear/components/LanguageAwareExternalContent";
import classNames from "classnames";

interface Props {
  // Actually substepIndex
  csticIndex: number;
  // Actually substepAmount
  csticAmount: number;
  def: LinearSubstep;
}

const CONFIG = {
  left: {
    cstic: SimpleCsticId(SHAFT_MACHINING_LEFT),
    title: "configurator.shaft.step.2.substep.3.sectionTitle.left",
    sections: [
      {
        predicate: function (value: string | null) {
          return showAxialThreadSection(value);
        },
        renderComponent: () => <MetricShaftAxialThreadSegment key={"axial"} side={"left"} />,
      },
      {
        predicate: function (value: string | null) {
          return showChamferedSection(value);
        },
        renderComponent: () => <MetricShaftChamferSegment key={"chamfer"} side={"left"} />,
      },
    ],
  },
  middle: {
    cstic: SimpleCsticId(SHAFT_MACHINING_MIDDLE),
    title: "configurator.shaft.step.2.substep.3.sectionTitle.middle",
    sections: [
      {
        predicate: function (value: string | null) {
          return showRadialThreadSection(value);
        },
        renderComponent: () => <MetricShaftRadialThreadSegment key={"radial"} />,
      },
    ],
  },
  right: {
    cstic: SimpleCsticId(SHAFT_MACHINING_RIGHT),
    title: "configurator.shaft.step.2.substep.3.sectionTitle.right",
    sections: [
      {
        predicate: function (value: string | null) {
          return showAxialThreadSection(value);
        },
        renderComponent: () => <MetricShaftAxialThreadSegment key={"axial"} side={"right"} />,
      },
      {
        predicate: function (value: string | null) {
          return showChamferedSection(value);
        },
        renderComponent: () => <MetricShaftChamferSegment key={"chamfer"} side={"right"} />,
      },
    ],
  },
};

export const MetricShaftMachiningExtraSubstep = ({ def, ...props }: Props) => {
  const xmlT = useXmlConfiguratorTranslations().t!;
  const { t } = useTranslation();

  const leftValue = useSelector(selectCstic(CONFIG.left.cstic))?.value ?? "";
  const middleValue = useSelector(selectCstic(CONFIG.middle.cstic))?.value ?? "";
  const rightValue = useSelector(selectCstic(CONFIG.right.cstic))?.value ?? "";

  const leftSections = CONFIG.left.sections.filter((section) => section.predicate(leftValue));
  const middleSections = CONFIG.middle.sections.filter((section) => section.predicate(middleValue));
  const rightSections = CONFIG.right.sections.filter((section) => section.predicate(rightValue));

  const isEmpty = leftSections.length === 0 && middleSections.length === 0 && rightSections.length === 0;

  return (
    <SubstepFrame title={""} description="" isPicked={true} errorMessage={""} {...props}>
      {isEmpty && <div className={classes.emptyTitle}>Nothing to see here (T)</div>}
      {!isEmpty && (
        <div className={classes.tileContainer}>
          <div className={classes.left}>
            <LanguageAwareExternalContent
              content={CONFIG.left.title}
              loadedClassname={classNames("scha__lc__external-label--shaft", classes.sectionTitle)}
            />

            {/*<div className={classes.sectionContainer}>{leftSections.map((section) => section.renderComponent())}</div>*/}
            {leftSections.map((section) => section.renderComponent())}
          </div>
          <div className={classes.centre}>
            <LanguageAwareExternalContent
              content={CONFIG.middle.title}
              loadedClassname={classNames("scha__lc__external-label--shaft", classes.sectionTitle)}
            />

            {/*<div className={classes.sectionContainer}>{middleSections.map((section) => section.renderComponent())}</div>*/}
            {middleSections.map((section) => section.renderComponent())}
          </div>
          <div className={classes.right}>
            <LanguageAwareExternalContent
              content={CONFIG.right.title}
              loadedClassname={classNames("scha__lc__external-label--shaft", classes.sectionTitle)}
            />

            {/*<div className={classes.sectionContainer}>{rightSections.map((section) => section.renderComponent())}</div>*/}
            {rightSections.map((section) => section.renderComponent())}
          </div>
        </div>
      )}
    </SubstepFrame>
  );
};
